import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Primary app (oursystem) – used for Auth/Firestore/Storage
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");
// Secondary app (Qemplate-AI) – used ONLY to call AI functions
let aiFunctions = null;
let aiAuth = null;
try {
  const aiAppConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_QEMPLATE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_QEMPLATE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_QEMPLATE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_QEMPLATE_STORAGE_BUCKET,
    messagingSenderId:
      process.env.REACT_APP_FIREBASE_QEMPLATE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_QEMPLATE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_QEMPLATE_MEASUREMENT_ID,
  };
  // Only initialize the secondary app if all required vars exist
  if (
    aiAppConfig.apiKey &&
    aiAppConfig.authDomain &&
    aiAppConfig.projectId &&
    aiAppConfig.appId
  ) {
    const aiApp = initializeApp(aiAppConfig, "aiApp");
    aiFunctions = getFunctions(aiApp, "us-central1");
    aiAuth = getAuth(aiApp);
  }
} catch (_) {
  // Ignore secondary app init errors in environments where variables are missing
}

export { app, auth, db, storage, functions, aiFunctions, aiAuth };
